/**
 * Creator Academy in the athlete app: the shared catalogue types and functions
 * (@adthlete/common/utils/academy) and the links other screens use. The catalogue itself comes
 * from the server (useAcademyCatalogue).
 */
export * from '@adthlete/common/utils/academy'

/** Opens the Academy playing this lesson */
export const academyLessonPath = (id: string) => `/academy?v=${encodeURIComponent(id)}`
